import type { MarketplaceListing } from "./types";

export function isImportedDescriptionPlaceholder(description: string) {
  return /^Imported from (?:an active )?(?:eBay|Etsy)\.$/.test(description.trim()) || /^Imported from an active (?:eBay|Etsy) listing\.$/.test(description.trim());
}

/** Live source content and a saved local draft are separate records of truth. */
export function connectedListingContent(listing: MarketplaceListing) {
  const source = listing.observedChannel;
  const useSource = Boolean(source && listing.externalListingID === source.externalListingID && listing.externalAccountID === source.externalAccountID && !["draft", "ready", "failed", "publishing"].includes(listing.status));
  return {
    title: useSource ? source!.title : listing.title,
    description: useSource ? source!.description ?? "" : isImportedDescriptionPlaceholder(listing.description) ? "" : listing.description,
    price: useSource ? source!.price ?? listing.price : listing.price,
    photos: useSource ? source!.photos.map((photo) => photo.url) : listing.sourceImageURLs ?? [],
    hasSource: useSource
  };
}
